<template>
  <div>
    <a-modal
      :width="950"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel">
     <div slot="title">
        <other-icon type="detail"/>
        任务明细
     </div>
     <a-table :columns="columns" :data-source="showTasks" :scroll="{ y: 340 }" :pagination="false" class="dtTable" size="small">
        <template slot="actionName" slot-scope="text"><span :style="{color:text?'#000':'var(--light)'}">{{text || '正在办理中...' }}</span></template>
        <template slot="actionTime" slot-scope="text">{{text?getLocalTime(text):'&nbsp;'}}</template>
        <template slot="actionUser" slot-scope="text">{{text.name?text.name:'&nbsp;' }}</template>
     </a-table>
    </a-modal>
  </div>
</template>
<script>
import OtherIcon from './icons.vue'
export default {
  data() {
    return {
      visible:false,
      detail:{},
      columns:[
            {
                title: '任务名称',
                dataIndex: 'name',
            },
            {
                title: '状态',
                dataIndex: 'actionName',
                scopedSlots: { customRender: 'actionName' },
            },
            {
                title: '办理时间',
                dataIndex: 'actionTime',
                scopedSlots: { customRender: 'actionTime' },
            },{
                title: '办理用户',
                dataIndex: 'actionUser',
                scopedSlots: { customRender: 'actionUser' },
            }]
    }
  },
  components:{
    OtherIcon
  },
  inject:['reload','getLocalTime'],
  computed:{
    showTasks(){
      if(this.detail.tasks){
          return this.detail.tasks.map((item)=>{
          let obj = item;
          if(!obj.actionUser){
              obj.actionUser = {}
          }
          return obj;
        });
      }
      
    }
  },
  methods: {
    showModal(e) {
        this.detail = e;
        console.log(this.detail);
        this.visible = true;
    },
    handleOk(e) {
     this.visible = false;
     this.detail = {};
    },
    handleCancel(e) {
      this.visible = false;
    },
  },
};
</script>
<style>
.dtTable .ant-table-thead th{
    font-weight:bold;
    color:var(--nowColor);
    background:#f5f5f5;
}
.dtTable tr.ant-table-row td{
 font-size: 12px;
}

</style>


// WEBPACK FOOTER //
// src/components/todoCenter/detailmodal.vue